const activityLogData = {
  activity: [
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-19 14:12:18.9326',
      domain_id: null,
      event: 'install_wordpress',
      site_id: '150046',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-19 19:51:05.5392',
      domain_id: null,
      event: 'assign_domain',
      site_id: '151285',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-20 13:47:06.7540',
      domain_id: null,
      event: 'pending_url_dns_done',
      site_id: '180733',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-21 14:28:23.4346',
      domain_id: null,
      event: 'codeguard_active',
      site_id: '179268',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-21 14:28:57.4666',
      domain_id: null,
      event: 'wp_sso_requested',
      site_id: '179268',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-25 11:53:42.7124',
      domain_id: null,
      event: 'wp_sso_requested',
      site_id: '151285',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{}',
      date_entry: '2024-11-26 09:59:49.0346',
      domain_id: null,
      event: 'create_wp_theme',
      site_id: '150046',
      status: 'success',
      tenant_id: '1555093',
    },
    {
      account_id: '1296393',
      addon_id: null,
      data: '{"domain":"testdummy-2.com"}',
      date_entry: '2024-12-04 10:43:06.6289',
      domain_id: '505636',
      event: 'assign_domain',
      site_id: null,
      status: 'success',
      tenant_id: '1555093',
    },
  ],
};

export default activityLogData;
